import { ActionButton } from '@if/mui'
import { ButtonProps } from '@mui/material'
import { useDownloadSignedContractPdf } from '@src/data/api/credit-api/files-api'
import { CreditApplication } from '@src/types/CreditApplicationSchema'
import { useTranslation } from 'react-i18next'

interface Props extends ButtonProps {
  creditApp: CreditApplication
}

const DownloadContractButton = ({ creditApp }: Props) => {
  const { t } = useTranslation()
  const [downloadPdf, isDownloading] = useDownloadSignedContractPdf(creditApp.financingProgramId, creditApp.id)

  return (
    <ActionButton
      fullWidth
      emphasis="principal"
      loading={isDownloading}
      onClick={() => downloadPdf(creditApp.contract.cvtNumber)}
    >
      {t('worksheet.download')}
    </ActionButton>
  )
}

export default DownloadContractButton
